document.addEventListener("DOMContentLoaded", () => {
  // Element references
  const $body = document.body;
  const $stickyNav = document.querySelector(".js-site-navigation");
  const $mainHeader = document.querySelector(".js-site-header");
  const $siteSearch = document.querySelector(".js-header-site-search");
  const $mobileNav = document.querySelector(".site-header__mobile-tools");
  const $promoBanner = document.querySelector(".promo-fixed");

  if (!$stickyNav || !$mainHeader || !$siteSearch || !$mobileNav) return;

  // Configuration
  const { universityPressThemeSettings } = window;
  const fixedHeaderBreakpoint = universityPressThemeSettings.fixed_header_breakpoint ? universityPressThemeSettings.fixed_header_breakpoint : 950;

  // Cached values
  const stickyNavTop = $stickyNav.getBoundingClientRect().top + window.scrollY;
  const stickyNavHeight = $stickyNav.offsetHeight;
  const mobileNavTop = $mobileNav.getBoundingClientRect().top + window.scrollY;
  const promoBannerVisible = $promoBanner && !localStorage.getItem("popupClosed");

  // Promo banner height helper
  const getPromoBannerHeight = () =>
      promoBannerVisible ? $promoBanner.offsetHeight : 0;

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const promoHeight = getPromoBannerHeight();

    const stickyNavTrigger = scrollY >= stickyNavTop;
    const withinPromoRange = $stickyNav.getBoundingClientRect().top <= promoHeight;

    // Handle promo adjustments
    if (promoBannerVisible && withinPromoRange) {
      $stickyNav.style.top = `${promoHeight}px`;
      $siteSearch.style.top = `${promoHeight + stickyNavHeight}px`;
      $stickyNav.classList.add("fixed-nav");
      $siteSearch.classList.add("fixed-nav");
    } else {
      $stickyNav.style.top = "";
      $siteSearch.style.top = "";
      $stickyNav.classList.remove("fixed-nav");
      $siteSearch.classList.remove("fixed-nav");
    }

    // Handle sticky nav + search
    if (stickyNavTrigger) {
      $body.classList.add("fixed-header");
      $stickyNav.classList.add("fixed-nav");
      $siteSearch.classList.add("fixed-nav");
      $mainHeader.style.paddingBottom = `${stickyNavHeight}px`;

      if (!promoBannerVisible) {
        $siteSearch.style.top = `${stickyNavHeight}px`;
      }
    } else {
      $body.classList.remove("fixed-header");
      $stickyNav.classList.remove("fixed-nav");
      $siteSearch.classList.remove("fixed-nav");
      $mainHeader.removeAttribute("style");
      $siteSearch.removeAttribute("style");
    }
  };

  const handleMobileScroll = () => {
    const scrollY = window.scrollY;
    const promoHeight = getPromoBannerHeight();
    const triggerFixed = scrollY >= mobileNavTop;

    if (triggerFixed) {
      if (promoBannerVisible) {
        $mobileNav.style.top = `${promoHeight}px`;
      } else {
        $mobileNav.style.top = "";
      }
      $mobileNav.classList.add("fixed-nav-mob");
    } else {
      $mobileNav.classList.remove("fixed-nav-mob");
      $mobileNav.style.top = "";
    }
  };

  // Init scroll listeners
  if (window.innerWidth >= fixedHeaderBreakpoint) {
    window.addEventListener("scroll", handleScroll);
  } else {
    window.addEventListener("scroll", handleMobileScroll);
    window.addEventListener("resize", handleMobileScroll);
  }
});
